module.exports = __webpack_public_path__ + "media/images/flag-1784147e4ed7064d373e9f4cd85eab68.svg";